export default "__VITE_ASSET__Bq$a8Ozg__"